import * as React from 'react';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { INavStyles } from '@fluentui/react/lib/Nav';
import { User } from '../../system/User';

import AppNav from './AppNav';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { t } from 'i18next';
import { useMenuPermission } from '../../shared/context/MenuPermissionContext';

const navStylesWhenNotInPanel: Partial<INavStyles> = {
  root: {
    height: '100%',
    boxSizing: 'border-box',
    border: '1px solid #eee',
    overflowY: 'auto',
  },
};

interface ISidebarProps {
  isOpen: boolean;
  dismissPanel: () => void;
  user: User;
  isMobile?: boolean;
}

const Sidebar: React.FC<ISidebarProps> = (props) => {
  const { menu: menudata, loading } = useMenuPermission();

  return (
    <React.Fragment>
      {props.isMobile ? (
        <Panel
          isLightDismiss
          isOpen={props.isOpen}
          onDismiss={props.dismissPanel}
          closeButtonAriaLabel="Cerrar"
          type={PanelType.smallFixedNear}
          styles={{ content: { paddingLeft: '0.5rem' } }}
          >
          {menudata[0]?.links.length && <AppNav user={props.user} onLinkClicked={props.dismissPanel} menudata={menudata} />}
          {loading && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}><Spinner size={SpinnerSize.medium} label={t("Cargando menú...")} /></div>}
        </Panel>
      ) : (
        <>
          {menudata[0]?.links.length && <AppNav user={props.user} styles={navStylesWhenNotInPanel} menudata={menudata} />}
          {loading && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}><Spinner size={SpinnerSize.medium} label={t("Cargando menú...")} /></div>}
        </>
      )}

    </React.Fragment>
  );
};

export default Sidebar;
